import { lazy } from 'react';

const OutgoingEdit = lazy(() => import('./OutgoingEdit'));

export default OutgoingEdit;